// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e017b2ed","553":"12c7de86","977":"c1c70490"}[chunkId] + ".chunk.js";
};